import { MainPageProperties } from './mainPageProperties';
import { PrimaryBanners } from './primaryBanners';
import { SecondaryBanners } from './secondaryBanners';
import { Announcements } from './announcements'
import { ClubeProvider } from './contextClube';
import { ModalFormsGeneric } from './modalForms/modalFormsGeneric'
import { ModalFormsMainPageProperties } from './modalForms/modalFormsMainPageProperties'

import { Container, Content } from './style';

export function Clube() {
    return(
        <Container>
            
            <div className="fill"></div>

            <Content>
                <ClubeProvider>
                    <MainPageProperties />
                    <PrimaryBanners />
                    <SecondaryBanners />
                    <Announcements />
                    <ModalFormsGeneric />
                    <ModalFormsMainPageProperties />
                </ClubeProvider>
            </Content>

        </Container>
    )
}
